export interface CloudflareMediaReviewAsset {
  status: string;
  relationship: "dvr_video" | "retained_source" | "unmatched";
  reviewRequired: boolean;
}

export const requiresMediaReview = (asset: CloudflareMediaReviewAsset): boolean =>
  asset.relationship === "unmatched" || asset.status !== "ready" || asset.reviewRequired;
